import React, {Component} from 'react';
import {Link} from 'react-router';
import _ from 'lodash';
import PropTypes from 'prop-types';
import style from './style.scss';

export default class SideMenu extends Component {

  static propTypes = {
    components: PropTypes.array,
    location: PropTypes.object,
    version: PropTypes.string,
  }

  inModifiers(path = '', section = '') {
    const pattern = new RegExp(`.*/modifiers[#]?[[${section}]*]?$`);
    return pattern.test(path);
  }

  render() {
    const {components, version, location} = this.props;
    const path = location.pathname;

    return (
      <div className={style.sidemenu}>
        <ul>
          <li>version {version}</li>
          <li className={style.separator}/>
          <li>
            <Link activeClassName={style.selected} to="/docs/getting-started">
              Getting Started
            </Link>
          </li>
          <CollapsingMenu
            isSelected={this.inModifiers(path)}
            path={'/docs/modifiers'}
            title={'Modifiers'}
            >
            <li> <a href="#layout">Layout</a></li>
            <li> <a href="#spacing">Spacing</a></li>
            <li> <a href="#colors">Colors</a></li>
            <li> <a href="#typography">Typography</a></li>
          </CollapsingMenu>
          <li>
            <Link activeClassName={style.selected} to="/docs/presets">
              Presets
            </Link>
          </li>
          <li>
            <Link activeClassName={style.selected} to="/docs/theme-manager">
              Theme Manager
            </Link>
          </li>
          <li className={style.separator}/>
          {_.map(components, (component, index) => {
            return (
              <li key={index}>
                <Link activeClassName={style.selected} to={`/docs/${component.displayName}`}>{component.displayName}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

const CollapsingMenu = ({isSelected, path, title, children}) => {
  return (
    <li className={isSelected && style.selected} key={title}>
      <Link activeClassName={style.selected} to={path}>
        <div>{title}</div>
      </Link>
      <ul>
        {children}
      </ul>
    </li>
  );
};

CollapsingMenu.propTypes = {
  isSelected: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.array,
};



// WEBPACK FOOTER //
// ./components/SideMenu/index.js